module.exports = __webpack_public_path__ + "static/media/anfora_dorada_final.7ac61598.jpg";